import { createSvgIcon } from '@automata/mui-theme';
export const LiconicStoreXstx110Icon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.9992 9.34542C50.6188 8.98741 51.3825 8.98774 52.0018 9.3463L70.5021 20.057C71.1197 20.4145 71.5 21.0742 71.5 21.7878V70.7074C71.5 71.4293 71.1109 72.0952 70.482 72.4497L43.481 87.6685C42.8736 88.0108 42.1319 88.0122 41.5233 87.6721L24.8846 78.3739C24.5798 78.2036 24.3249 77.9565 24.1452 77.6571L22.785 75.39C22.5985 75.0792 22.5 74.7235 22.5 74.3611V26.7495C22.5 26.12 22.7964 25.5273 23.3 25.1495L24.817 24.0118C25.4556 23.5329 26.3131 23.482 27 23.87V23.7881C27 23.0738 27.381 22.4137 27.9994 22.0564L49.9992 9.34542ZM50.9992 12.2324L30 24.3652V24.7924C30 25.3229 29.7893 25.8316 29.4142 26.2067L28.8505 26.7704C28.1764 27.4445 27.1201 27.5491 26.3269 27.0202L26.051 26.8363L25.5 27.2495V74.0841L26.5806 75.8851L42.4969 84.7795L68.5 70.1231V22.3644L50.9992 12.2324Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.8673 21.5018C70.1424 21.9807 69.9772 22.5919 69.4983 22.867L46.2515 36.2216C45.7822 36.4912 45.2039 36.487 44.7385 36.2107L28.9896 26.8598C28.5147 26.5778 28.3583 25.9643 28.6403 25.4894C28.9223 25.0145 29.5358 24.8581 30.0107 25.1401L45.5085 34.3419L68.502 21.1328C68.9809 20.8577 69.5922 21.0229 69.8673 21.5018Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 34.5C46.5523 34.5 47 34.9477 47 35.5V83.5C47 84.0523 46.5523 84.5 46 84.5C45.4477 84.5 45 84.0523 45 83.5V35.5C45 34.9477 45.4477 34.5 46 34.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.4285 35.6289C46.6336 36.1417 46.3842 36.7236 45.8714 36.9287L44 37.6773V86.5003C44 87.0526 43.5523 87.5003 43 87.5003C42.4477 87.5003 42 87.0526 42 86.5003V37.3388C42 36.7254 42.3734 36.1739 42.9429 35.9461L45.1286 35.0718C45.6414 34.8667 46.2234 35.1161 46.4285 35.6289Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27 32C27.5523 32 28 32.4477 28 33V42C28 42.5523 27.5523 43 27 43C26.4477 43 26 42.5523 26 42V33C26 32.4477 26.4477 32 27 32Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 34C30.5523 34 31 34.4477 31 35V44C31 44.5523 30.5523 45 30 45C29.4477 45 29 44.5523 29 44V35C29 34.4477 29.4477 34 30 34Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.3372 38.0064L34.3373 44.5297L39.2874 47.409L39.2871 40.8078L34.3372 38.0064ZM33.4861 35.5231C32.9823 35.238 32.5627 35.4738 32.5627 36.0421L32.5628 44.5537C32.5628 45.0848 32.9311 45.7147 33.4016 45.9883L40.1261 49.8999C40.6345 50.1955 41.0619 49.9617 41.0619 49.3879L41.0616 40.7705C41.0615 40.234 40.686 39.5979 40.2105 39.3288L33.4861 35.5231Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.6957 26.2599C23.1046 25.5394 24.0202 25.2868 24.7407 25.6957L43.2407 36.1957C43.9611 36.6046 44.2137 37.5202 43.8048 38.2407C43.3959 38.9611 42.4803 39.2137 41.7599 38.8048L23.2599 28.3048C22.5394 27.8959 22.2868 26.9803 22.6957 26.2599Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 46C35.5523 46 36 46.4477 36 47V82C36 82.5523 35.5523 83 35 83C34.4477 83 34 82.5523 34 82V47C34 46.4477 34.4477 46 35 46ZM40 48.5C40.5523 48.5 41 48.9477 41 49.5V85C41 85.5523 40.5523 86 40 86C39.4477 86 39 85.5523 39 85V49.5C39 48.9477 39.4477 48.5 40 48.5Z"
    />
  </svg>,
  'LiconicStoreXstx110Icon'
);
